export const environment = {
    production: true,
     apiBaseUrl: 'https://apidev.kapitalnex.com'
  };
  